/* ==========================================================================
   MaxGlows — keep the retired white-teeth guide out of the cart   2026-09-05

   "המדריך לשיניים לבנות תוך 7 ימים" was retired on 3.9, but it still lands in
   the cart as a ₪0 line on nearly every order.

   WHERE IT COMES FROM  (measured on the live store, 3.9, with ?mgdebug=1)

     The browser only ever sends two add requests: the spray, and the theme's
     own gift "סודות המשיכה". Neither carries the guide - both were inspected
     and left untouched - and the cart still comes back holding it:

        2040ms  fetch ADD   id=<spray>            -> left untouched
        3111ms  fetch ADD   id=<gift>             -> left untouched
        3512ms  cart.js     items=3  guideInCart=true

     So the guide is added server-side, outside this page. Nothing done to an
     outgoing request can prevent it, which is why the earlier versions that
     edited the add payload never worked. It has to be removed after the fact.

   HOW IT IS REMOVED WITHOUT A REDRAW

     The bin sends the line number the drawer was drawn with, so deleting a
     line server-side and leaving the DOM alone breaks it - that was v4/v5
     ("הפרמטר line אינו חוקי"). Redrawing the whole drawer fixes the numbers
     but costs a visible refresh - that was v6.

     Neither is necessary. The stray line is dropped from the DOM and the
     remaining rows are renumbered exactly the way the Liquid numbers them
     (CartDrawer-Item-N / CartDrawer-Remove-N / Drawer-quantity-N and their
     data-index). The cart and the page agree, the bin works, and nothing is
     redrawn.

   NOT OURS: the two redraws after adding to cart are the theme's own gift
   blocks - the second add above asks the server for fresh sections, which is
   a redraw by definition. Confirmed by running the store with this file
   removed. Nothing here touches that.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__mgNoStrayGift) return;
  window.__mgNoStrayGift = true;

  var STRAY_PRODUCT_IDS = [8403831881816];

  /* Escaped, not literal: the selector must survive even if this file is ever
     served with the wrong charset. ("המדריך-לשיניים-לבנות-תוך-7-ימים") */
  var STRAY_HANDLE = '\u05d4\u05de\u05d3\u05e8\u05d9\u05da-\u05dc\u05e9\u05d9\u05e0\u05d9\u05d9\u05dd-\u05dc\u05d1\u05e0\u05d5\u05ea-\u05ea\u05d5\u05da-7-\u05d9\u05de\u05d9\u05dd';
  var STRAY_CLASS = 'cart-item--product-' + STRAY_HANDLE;

  var CART_WRITE = /\/cart\/(add|change|update)/;

  /* ---------- 1. never let it be seen --------------------------------- */

  (function hideRule() {
    try {
      /* The handle is Hebrew and a bare class selector built from it does not
         survive the CSS parser - matched as an attribute substring instead,
         which takes a quoted string and needs no escaping. */
      var style = document.createElement('style');
      style.textContent = '[class*="' + STRAY_CLASS + '"]{display:none !important;}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* ---------- 2. keep the page and the cart telling the same story ----- */

  /* Mirrors blocks/cart-drawer_items.liquid, which numbers every row with
     item.index + 1 in four places. Drop the stray row, renumber the rest. */
  function dropStrayRowsAndRenumber() {
    var rows = document.querySelectorAll('li.cart-item');
    if (!rows.length) return 0;

    var removed = 0;
    var n = 0;
    Array.prototype.forEach.call(rows, function (li) {
      if (li.className.indexOf(STRAY_CLASS) !== -1) {
        if (li.parentNode) li.parentNode.removeChild(li);
        removed++;
        return;
      }
      n++;
      li.setAttribute('data-index', n);
      li.id = 'CartDrawer-Item-' + n;

      var remove = li.querySelector('cart-remove-button');
      if (remove) {
        remove.setAttribute('data-index', n);
        remove.id = 'CartDrawer-Remove-' + n;
      }
      var qty = li.querySelector('.quantity__input');
      if (qty) {
        qty.setAttribute('data-index', n);
        qty.id = 'Drawer-quantity-' + n;
      }
      var err = li.querySelector('.cart-item__error');
      if (err) err.id = 'CartDrawer-LineItemError-' + n;
    });
    return removed;
  }


  /* ==================================================================
     THE VIP ADD-ON

     The card is the theme's own upsell block; everything below is
     presentation plus one click forwarder. No markup is rewritten and no
     setting is changed, so adding and removing the product still runs
     entirely through the theme.

     What it fixes, and why each one matters for how many people take it:
       - the title already names the three benefits, so nothing repeats them
       - only the 40px switch was tappable; the whole card is now the target
       - "on" was easy to miss; the card now lights up
       - the proof line sat outside the card; it moves inside, next to the
         decision
     ================================================================== */
  var VIP_HANDLE = '\u05d1\u05d9\u05d8\u05d5\u05d7-\u05de\u05e9\u05dc\u05d5\u05d7-\u05e2\u05d3\u05d9\u05e4\u05d5\u05ea-\u05d0\u05e8\u05d9\u05d6\u05d4';   /* the VIP add-on product */
  var VIP_SEL = 'cart-drawer-upsell[data-handle="' + VIP_HANDLE + '"]';

  (function vipStyle() {
    try {
      var css = [
        /* the card */
        VIP_SEL + '{display:block;direction:rtl;position:relative;overflow:hidden;',
        'border-radius:1.4rem;border:1.5px solid #e3d7ff;',
        'background:linear-gradient(180deg,#faf7ff 0%,#f4ecff 100%);',
        'transition:border-color .18s ease,background .18s ease,box-shadow .18s ease;}',

        /* on - unmistakable without shouting */
        VIP_SEL + '[data-selected="true"]{border-color:#a473df;',
        'background:linear-gradient(180deg,#f5edff 0%,#ece0ff 100%);',
        'box-shadow:0 0 0 3px rgba(164,115,223,.16);}',

        /* the recommendation flag, in the corner the eye reaches first in Hebrew */
        VIP_SEL + '::before{content:"\u05de\u05d5\u05de\u05dc\u05e5";position:absolute;top:0;right:0;z-index:1;',
        'background:#a473df;color:#fff;font-size:.95rem;font-weight:700;line-height:1;',
        'padding:.4rem .8rem;border-radius:0 1.4rem 0 1rem;letter-spacing:.02em;}',

        /* the proof, inside the card where the decision is made */
        VIP_SEL + '::after{content:"\ud83d\udd25 84% \u05de\u05d4\u05e8\u05d5\u05db\u05e9\u05d9\u05dd \u05de\u05d5\u05e1\u05d9\u05e4\u05d9\u05dd \u05d0\u05ea \u05d6\u05d4";display:block;',
        'border-top:1px solid #e8dcff;background:rgba(255,255,255,.45);',
        'padding:.55rem 1.2rem;font-size:1.1rem;line-height:1.4;color:#6b5a86;',
        'text-align:right;}',

        /* the row. The top padding clears the corner flag so the flag never
           sits on top of the image or the title. */
        VIP_SEL + ' .upsell__container{display:flex;align-items:center;gap:.9rem;',
        'padding:1.9rem 1.2rem 1.1rem;cursor:pointer;}',

        VIP_SEL + ' .upsell__image{width:4rem;min-width:4rem;height:4rem;border-radius:.9rem;',
        'overflow:hidden;background:#fff;border:1px solid #e8dcff;}',
        VIP_SEL + ' .upsell__image__img{width:100%;height:100%;object-fit:contain;}',

        /* the title now carries the whole offer on its own, so it gets the
           room the three benefit lines used to take */
        VIP_SEL + ' .upsell__content{flex:1 1 auto;min-width:0;}',
        VIP_SEL + ' .upsell__title{display:flex;align-items:center;column-gap:.7rem;',
        'row-gap:.6rem;flex-wrap:wrap;}',
        VIP_SEL + ' .upsell__title h3{margin:0;font-size:1.3rem;font-weight:700;',
        'line-height:1.4;color:#1f1533;}',

        /* the price reads as an addition, not as a second product */
        VIP_SEL + ' .upsell__price{margin:0;}',
        VIP_SEL + ' .upsell__price .regular-price{display:inline-block;background:#fff;',
        'border:1px solid #d9c6f5;color:#6d3fa8;font-size:1.15rem;font-weight:700;',
        'padding:.25rem .7rem;border-radius:999px;white-space:nowrap;line-height:1.25;}',
        /* a compare-at price, if one is ever set, reads as the saving - it is
           not hidden, only kept quiet next to the pill */
        VIP_SEL + ' .upsell__price .compare-price{font-size:1.15rem;color:#8b7aa6;',
        'text-decoration:line-through;margin-inline-start:.4rem;}',
        VIP_SEL + ' .upsell__price .compare-price.hidden{display:none;}',

        VIP_SEL + ' .toggle-switch{flex:0 0 auto;}',

        /* the old proof line and its arrow, now that both live in the card */
        '#CartDrawer .cart-drawer-text-with-icon:has(em){display:none;}',

        '@media screen and (max-width:480px){',
        VIP_SEL + ' .upsell__container{padding:1.8rem 1rem 1rem;gap:.8rem;}',
        VIP_SEL + ' .upsell__image{width:3.6rem;min-width:3.6rem;height:3.6rem;}',
        VIP_SEL + ' .upsell__title h3{font-size:1.25rem;line-height:1.4;}',
        VIP_SEL + ' .upsell__price .regular-price{font-size:1.1rem;}',
        VIP_SEL + '::after{padding:.5rem 1rem;font-size:1.05rem;}}'
      ].join('');

      var style = document.createElement('style');
      style.setAttribute('data-mg', 'vip');
      style.textContent = css;
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* The whole card takes the tap, not just the switch. Delegated, so it keeps
     working through every redraw of the drawer, and it forwards the click
     rather than touching the cart itself - the theme still owns that. */
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest(VIP_SEL);
    if (!card) return;
    var toggle = card.querySelector('.upsell__toggle-switch');
    if (!toggle || toggle === e.target || toggle.contains(e.target)) return;
    e.preventDefault();
    toggle.click();
  }, false);


  /* ==================================================================
     THE DRAWER MUST REACH THE BOTTOM OF THE SCREEN

     Measured on the live store (3.9): the drawer element itself is already
     full height - top 0, bottom 656 on a 656px viewport - but its inner
     panel is only as tall as its content and carries no background of its
     own. With a subscription in the cart there is an extra line and the
     content happens to fill the screen; with a one-time purchase it is
     shorter, ends just under the checkout button, and the product page
     shows through underneath.

     min-height rather than height, so a long cart still scrolls normally.
     ================================================================== */
  (function fillDrawer() {
    try {
      var style = document.createElement('style');
      style.setAttribute('data-mg', 'drawer-fill');
      /* Two floors, because one of them moves: 100% leans on the parent's
         height, which iOS recalculates while Safari's address bar slides in
         and out - that is the "sometimes" in the panel sometimes ending short
         with the page showing through. 100dvh is the full dynamic viewport
         and does not flinch when the bar moves; older browsers that don't
         know it keep the 100% line. */
      /* the full-width mobile drawer covers the screen anyway, so the whole
         fixed container gets the background too - whatever the inner panel
         measures on any given open, the page behind cannot peek through */
      style.textContent =
        '#CartDrawer .drawer__inner{min-height:100%;background:#fff;}' +
        '@supports (min-height:100dvh){#CartDrawer .drawer__inner{min-height:100dvh;}}' +
        '@media screen and (max-width:749px){' +
        'cart-drawer.cart-drawer--mobile-width-full #CartDrawer{background:#fff;}}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* ==================================================================
     THE GIFTS BOX APPEARS ONCE, COMPLETE

     Adding the spray sets off a chain the page cannot shorten: the theme's
     gift blocks each add their own gift with a fresh drawer render between
     them, and the retired guide arrives server-side in the middle and is
     removed again. Seen live (3.9), the gifts panel counted 2 - 4 - 3 while
     that chain ran.

     The chain itself belongs to the theme and keeps running untouched. What
     changes is only what the customer sees: from the moment an add-to-cart
     leaves a closed drawer until the cart has been quiet for a beat, the
     gifts panel stays hidden, then fades in once - complete, in order.

     A closed drawer is the tell for "this is the opening chain". Later
     writes with the drawer already open (the VIP switch, an upsell toggle)
     never hide the panel.
     ================================================================== */
  var settle = (function () {
    var QUIET_MS = 900;   /* the chain is done when the cart stays quiet this long */
    var CAP_MS = 7000;    /* and never hide the panel longer than this */
    var quiet = null;
    var cap = null;
    var on = false;

    try {
      var style = document.createElement('style');
      style.setAttribute('data-mg', 'settle');
      style.textContent =
        'cart-drawer.mg-settling .mg-gifts{display:none !important;}' +
        'cart-drawer .mg-gifts{animation:mgGiftsIn .35s ease both;}' +
        'cart-drawer.mg-settling .mg-payeo-line{visibility:hidden !important;}' +
        'cart-drawer .mg-payeo-line{animation:mgGiftsIn .35s ease both;}' +
        '@keyframes mgGiftsIn{from{opacity:0;transform:translateY(4px);}to{opacity:1;transform:none;}}' +
        '@media (prefers-reduced-motion: reduce){cart-drawer .mg-gifts{animation:none;}}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}

    function drawer() { return document.querySelector('cart-drawer'); }

    function end() {
      if (quiet) { clearTimeout(quiet); quiet = null; }
      if (cap) { clearTimeout(cap); cap = null; }
      on = false;
      var d = drawer();
      if (d) d.classList.remove('mg-settling');
    }

    function touch() {
      if (!on) return;
      if (quiet) clearTimeout(quiet);
      quiet = setTimeout(end, QUIET_MS);
    }

    function begin() {
      if (!on) {
        var d = drawer();
        if (!d) return;
        on = true;
        d.classList.add('mg-settling');
        cap = setTimeout(end, CAP_MS);
      }
      touch();
    }

    /* an add that leaves a CLOSED drawer starts the chain; anything else
       only keeps an already-running window open */
    function onCartWrite(url) {
      var d = drawer();
      if (/\/cart\/add/.test(url) && d && !d.classList.contains('active')) begin();
      else touch();
    }

    /* Payeo writes a "תדירות מנוי: ..." line under the subscription item
       after every redraw of the drawer. Three redraws in the opening chain
       = the line popping in three times. It is tagged the moment it is
       inserted (a MutationObserver runs before paint) and the CSS above
       keeps it invisible - layout intact, so nothing jumps - until the
       chain is over, when it fades in once with the gifts. */
    var PAYEO_LINE = /^\s*תדירות מנוי/;
    function tagPayeoLine(root) {
      if (!root || root.nodeType !== 1) return;
      var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.classList.contains('mg-payeo-line')) continue;
        if (!PAYEO_LINE.test(el.textContent || '')) continue;
        var leaf = true;
        for (var c = 0; c < el.children.length; c++) {
          if (PAYEO_LINE.test(el.children[c].textContent || '')) { leaf = false; break; }
        }
        if (leaf) el.classList.add('mg-payeo-line');
      }
    }
    try {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'characterData') { tagPayeoLine(m.target.parentNode); continue; }
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            tagPayeoLine(n.nodeType === 3 ? n.parentNode : n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
      tagPayeoLine(drawer());
    } catch (e) {}

    return { onCartWrite: onCartWrite, touch: touch };
  })();

  /* A second, independent hide-window for just the "תדירות מנוי" line, used
     only by vipRenews below for the couple of extra redraws its own variant
     swap causes. Deliberately NOT sharing settle's window/class: that one
     also gates the gifts panel, and tying the two together made the gifts
     wait for the VIP swap's own network round trips before they were ever
     allowed to appear - a second, worse delay traded for the first fix. */
  var vipSwapHide = (function () {
    try {
      var style = document.createElement('style');
      style.setAttribute('data-mg', 'vip-swap-hide');
      style.textContent = 'cart-drawer.mg-vip-swapping .mg-payeo-line{visibility:hidden !important;}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}

    var timer = null;
    function drawer() { return document.querySelector('cart-drawer'); }

    function start() {
      if (timer) { clearTimeout(timer); timer = null; }
      var d = drawer();
      if (d) d.classList.add('mg-vip-swapping');
    }
    /* the theme's redraw (triggered by our own add/change responses) can lag
       a beat behind the response itself, so wait a little before revealing -
       otherwise the reveal can land mid-redraw and still catch a flash */
    function stopSoon() {
      var d = drawer();
      if (!d) return;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { timer = null; d.classList.remove('mg-vip-swapping'); }, 500);
    }

    return { start: start, stopSoon: stopSoon };
  })();

  /* cart.total_price sums the VIP line's real (undiscounted) Shopify price -
     same as the spray's own subscription line already does. Once the VIP
     line is riding the מנוי variant, that real total sits 4.97 NIS above
     what checkout actually charges (Payeo's 20% cut on the VIP line only
     applies at checkout, never in the drawer's own total - true for the
     spray line too, just not noticed there before). Purely a display fix:
     corrects the rendered subtotal text so the drawer matches checkout;
     never touches cart.total_price, cart.items, or anything checkout reads. */
  var vipTotalFix = (function () {
    var VIP_DELTA = 4.97;
    var onSub = false;

    function apply() {
      if (!onSub) return;
      var rows = document.querySelectorAll('.cart-drawer__totals .cart-drawer__totals__row__money');
      if (!rows.length) return;
      /* total-savings row (if shown) renders first, subtotal last - see
         blocks/cart_subtotals.liquid */
      var el = rows[rows.length - 1];
      var text = el.textContent || '';
      if (el.getAttribute('data-mg-fixed') === text) return; /* already our own write */
      var m = /(\d[\d,]*\.\d{2})/.exec(text);
      if (!m) return;
      var val = parseFloat(m[1].replace(/,/g, ''));
      if (isNaN(val)) return;
      var fixed = (Math.round((val - VIP_DELTA) * 100) / 100).toFixed(2);
      var newText = text.slice(0, m.index) + fixed + text.slice(m.index + m[1].length);
      el.setAttribute('data-mg-fixed', newText);
      el.textContent = newText;
    }

    function setState(isOnSub) {
      onSub = !!isOnSub;
      if (onSub) apply();
    }

    try {
      new MutationObserver(function () { apply(); }).observe(document.documentElement, {
        childList: true, subtree: true, characterData: true
      });
    } catch (e) {}

    return { setState: setState };
  })();

  /* ==================================================================
     THE CHECKOUT BUTTON SPEAKS HEBREW

     With a subscription in the cart, Payeo's own script intercepts the
     checkout click and rewrites the button label to "Processing..." - an
     English word on an all-Hebrew store, at the most sensitive moment of
     the purchase. The script is external and cannot be edited, so the swap
     is caught here the instant it happens and replaced with Hebrew.

     Only ever rewrites a label that says "Processing" - one write, after
     which the text no longer matches, so the observer cannot loop.
     ================================================================== */
  (function hebrewCheckout() {
    /* "\u05e2\u05d5\u05d1\u05e8\u05d9\u05dd \u05dc\u05ea\u05e9\u05dc\u05d5\u05dd \u05de\u05d0\u05d5\u05d1\u05d8\u05d7..." */
    var HEB = '\u05e2\u05d5\u05d1\u05e8\u05d9\u05dd \u05dc\u05ea\u05e9\u05dc\u05d5\u05dd \u05de\u05d0\u05d5\u05d1\u05d8\u05d7\u2026';
    var RX = /\.*\s*processing\s*\.*/i;

    function fix() {
      var btns = document.querySelectorAll(
        'button[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout'
      );
      Array.prototype.forEach.call(btns, function (b) {
        if (!RX.test(b.textContent || '')) return;
        var walker = document.createTreeWalker(b, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) {
          if (RX.test(n.nodeValue || '')) n.nodeValue = n.nodeValue.replace(RX, HEB);
        }
      });
    }

    try {
      new MutationObserver(fix).observe(document.documentElement, {
        childList: true, subtree: true, characterData: true
      });
    } catch (e) {}
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fix);
    } else {
      fix();
    }
  })();

  /* ==================================================================
     THE VIP RENEWS WITH THE SUBSCRIPTION, ON THE SAME SUBSCRIPTION

     v2 (8.9): the VIP used to sit on its OWN Payeo plan (2216493144, 0%) so
     it would renew at its own full price - but that made Payeo track it as
     a SECOND, separate subscription, and Payeo copies the order's shipping
     fee into every renewal it creates. Two subscriptions from one order ->
     the express fee charged twice: the VIP's renewal came back at 59.90
     (19.90 + the 39.90 express fee), not 19.90 (order #19499 and others).

     Fix: the VIP now rides the SPRAY'S OWN plan (the same
     _Subscription_Plan_ID as the sub line) - one subscription, one
     shipment fee, not two.

     That plan discounts 20% - proved at checkout (order #19472 and later):
     Payeo's own widget applies the PLAN'S real percentage to the LINE'S
     real Shopify price, no matter what the _Subscription_Discount_Value
     property says (tried 20, tried 0 - both still landed at -3.98 off
     19.90). So for the VIP to still cost 19.90 after that 20% cut, its
     real Shopify price has to be higher: a second variant of the VIP
     product, "מנוי" (id 44739457450072), priced 24.88 - 24.88 x 0.80 =
     19.90. The original variant, "חד פעמי" (44129537523800, 19.90), is
     untouched and is what a one-time cart keeps or reverts to.

     A cart line's variant can't be swapped in place, so going from
     one-time to subscribed (and back) removes the old line and re-adds the
     new variant - the same remove-then-add the "off" path already used.

     The properties written on the מנוי line are cosmetic only (what
     Payeo's own UI and the order show under the VIP) - the real charge is
     the plan's real percentage off the מנוי variant's real price, always
     19.90 to the cent. Done whenever a subscription spray line is in the
     cart, kept in sync on every cart write. A one-time cart never gets
     touched.
     ================================================================== */
  (function vipRenews() {

    var VIP_VARIANT_REGULAR = 44129537523800;   /* "חד פעמי" - 19.90, what a one-time cart keeps */
    var VIP_VARIANT_SUB = 44739457450072;        /* "מנוי" - 24.88; the spray's plan real 20% cut on
                                                     this real Shopify price lands the actual charge
                                                     at 19.90 */
    var PLAN_KEY = '_Subscription_Plan_ID';
    var MG_MARK = '_mg_vip_plan';               /* so our own write is recognisable */

    var busy = false;
    var fixes = 0;
    var MAX_FIXES = 40;                          /* per page - a loop guard only; a customer toggling the
                                                    subscription on and off costs one fix each way */

    function isVipLine(it) {
      return String(it.variant_id) === String(VIP_VARIANT_REGULAR) || String(it.variant_id) === String(VIP_VARIANT_SUB);
    }

    function isSubLine(it) {
      var p = (it && it.properties) || {};
      return !!p[PLAN_KEY] && !isVipLine(it);
    }

    /* Cosmetic only - what shows under the VIP at checkout and in the order.
       The real charge is the plan's real percentage off the מנוי variant's
       real Shopify price (see comment above). */
    function planProps(subLine) {
      var sp = (subLine && subLine.properties) || {};
      var props = {};
      props[PLAN_KEY] = sp[PLAN_KEY];
      props['חבילה'] = sp['חבילה'] || sp['_Subscription_Plan_Name'] || '';
      props['_Subscription_Plan_Name'] = sp['_Subscription_Plan_Name'] || sp['חבילה'] || '';
      props['_Subscription_Price_Per_Delivery'] = '19.90';
      props['_Subscription_Compare_At_Price'] = '19.90';
      props['_Subscription_Discount_Type'] = 'percentage';
      props['_Subscription_Discount_Value'] = '0';
      props['_Subscription_Currency'] = sp['_Subscription_Currency'] || '₪';
      props[MG_MARK] = '1';
      return props;
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function reconcile() {
      if (busy || fixes >= MAX_FIXES) return;
      busy = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var vip = null, sub = null;
          items.forEach(function (it) {
            if (isVipLine(it)) vip = it;
            else if (isSubLine(it)) sub = sub || it;
          });
          if (!vip) return null;

          var onSubVariant = String(vip.variant_id) === String(VIP_VARIANT_SUB);
          var planMatches = !!sub && onSubVariant &&
            String((vip.properties || {})[PLAN_KEY]) === String((sub.properties || {})[PLAN_KEY]);
          vipTotalFix.setState(onSubVariant);

          if (sub && !planMatches) {
            /* subscription in the cart, VIP not (yet) riding its plan -> swap to the מנוי variant.
               The swap is two writes (remove, then add) - by the time they land, the settle
               window from the opening chain has usually already ended, so the "תדירות מנוי"
               line would flash and reposition twice while this runs. Re-hide just that line
               for the duration of the swap - NOT settle's own window, which also gates the
               gifts panel and must not wait on this. */
            fixes++;
            vipSwapHide.start();
            return post('/cart/change.js', { id: vip.key, quantity: 0 })
              .then(function () {
                return post('/cart/add.js', { items: [{ id: VIP_VARIANT_SUB, quantity: vip.quantity, properties: planProps(sub) }] });
              })
              .then(function () { announce('vip-plan-on'); vipSwapHide.stopSoon(); });
          }
          if (!sub && onSubVariant) {
            /* subscription gone, VIP still on the מנוי variant -> swap back to the plain one-time variant */
            fixes++;
            vipSwapHide.start();
            return post('/cart/change.js', { id: vip.key, quantity: 0 })
              .then(function () { return post('/cart/add.js', { items: [{ id: VIP_VARIANT_REGULAR, quantity: vip.quantity }] }); })
              .then(function () { announce('vip-plan-off'); vipSwapHide.stopSoon(); });
          }
          return null;
        })
        /* if either write in the swap fails, don't leave the payeo-line
           hidden forever - a no-op if the swap never started */
        .catch(function () { vipSwapHide.stopSoon(); })
        .then(function () { busy = false; });
    }

    function announce(what) {
      try { document.dispatchEvent(new CustomEvent('mg:vip-plan', { detail: what })); } catch (e) {}
      /* the drawer does not need redrawing - the VIP line is hidden in it -
         but Payeo's own widget listens for cart changes, so let it know */
      try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
    }

    var timer = null;
    function soon() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { timer = null; reconcile(); }, 350);
    }

    /* every cart write (adds, Payeo's own property updates, quantity changes)
       is followed by a look at the cart. The 350ms coalesces the opening
       chain into one look at the end. */
    document.addEventListener('mg:cart-written', soon);

    /* Belt and suspenders: reconcile() can only see a subscription once it
       shows up as _Subscription_Plan_ID on the spray's actual cart line -
       which depends on Payeo's own timing and on that write happening
       through a request our fetch/XHR wrapper actually sees. Rather than
       assume either one, also re-check on any click or change anywhere on
       the page (same broad net assets/mg-subscription.js already uses to
       track the widget) and on a short bounded poll for the first 15s -
       cheap (reconcile() is a no-op once the state is already correct) and
       closes the gap regardless of what causes it. */
    document.addEventListener('click', soon, true);
    document.addEventListener('change', soon, true);
    (function poll() {
      var deadline = poll.deadline || (poll.deadline = Date.now() + 15000);
      if (Date.now() > deadline) return;
      soon();
      setTimeout(poll, 1500);
    })();

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon);
    else soon();
  })();

  /* ---------- 3. and take it out of the cart itself -------------------- */

  var MAX_SWEEPS = 4;
  var sweeps = 0;
  var busy = false;

  function sweep() {
    if (busy || sweeps >= MAX_SWEEPS) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = false;
        ((cart && cart.items) || []).forEach(function (it) {
          if (STRAY_PRODUCT_IDS.indexOf(it.product_id) !== -1) {
            updates[it.variant_id] = 0;
            found = true;
          }
        });
        if (!found) return;

        sweeps++;
        /* No `sections`: asking for them is what makes the server hand back a
           drawer to redraw, and the numbering is corrected here instead. */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function () { dropStrayRowsAndRenumber(); })
          .catch(function () {});
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var queued = false;
  function queue(delay) {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; sweep(); }, delay || 200);
  }

  /* ---------- wiring --------------------------------------------------- */

  /* The drawer is re-rendered by the theme on every cart change, which brings
     the stray row back into the DOM with fresh numbering. Each render is
     followed up: the row goes, the numbers close the gap. */
  /* Matched as an attribute substring, never as a class selector: the handle
     is Hebrew, and building a class selector out of it is what silently broke
     an earlier version's CSS. */
  var STRAY_SELECTOR = 'li.cart-item[class*="' + STRAY_CLASS + '"]';

  new MutationObserver(function () {
    if (document.querySelector(STRAY_SELECTOR)) dropStrayRowsAndRenumber();
  }).observe(document.documentElement, { childList: true, subtree: true });

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      /* bound to window, never to the caller: native fetch refuses any other
         receiver, and a strict-mode caller would hand us undefined */
      var p = origFetch.apply(window, arguments);
      var url = '';
      try {
        var input = arguments[0];
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      if (CART_WRITE.test(url)) {
        try { settle.onCartWrite(url); } catch (e) {}
        try {
          p.then(function () {
            settle.touch();
            try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
          }, function () {});
        } catch (e) {}
        if (!busy) {
          try { p.then(function () { queue(200); }, function () {}); } catch (e) {}
        }
      }
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url || '');
    if (CART_WRITE.test(u)) {
      try { settle.onCartWrite(u); } catch (e) {}
      this.addEventListener('load', function () {
        try { settle.touch(); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
        if (!busy) queue(200);
      });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { queue(0); });
  } else {
    queue(0);
  }
})();
